import React from 'react';
import { useSelector } from 'react-redux';
import { Empty, message } from 'antd';
import HouseCard from '../HouseCard';
import { useItemClick } from '../hooks/itemClick';
import {
  createAcceptanceSlug,
  parseAcceptanceSlug,
} from '../../../../../shared/packages/acceptance';
import {
  useSearchParamsMethods,
  useSearchParamsSelector,
} from '../../../../../shared/packages/searchParamsManager';
import {
  searchParamKeys,
  searchParamSelectors,
} from '../../../../../shared/configs/searchParams';
import { useEvent } from '../../../../../../../hooks/useEvent';
import OptionButton from '../../../../../shared/ui/OptionButton';
import { useDeleteAcceptance } from '../../../../../api/deleteAcceptance';
import { useAcceptanceViewInfoInvalidate } from '../../../../../api/acceptanceViewInfo';
import DownloadSummarySlot from '../DownloadSummarySlot';
import styles from './index.module.scss';

const emptyArr = [];

const selectCanDelete = (store) =>
  store.authentication.userInfo?.CanDeleteAcceptance;

const PanelContent = ({ result, houses = emptyArr, acceptanceId }) => {
  const canDelete = useSelector(selectCanDelete);

  return (
    <>
      <div className={styles.header}>
        {Boolean(result) && <p className={styles.result}>{result}</p>}
        {canDelete && <DeleteBtn acceptanceId={acceptanceId} />}
      </div>

      {houses.length ? (
        <Content houses={houses} acceptanceId={acceptanceId} />
      ) : (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="Нет данных по домам"
        />
      )}
    </>
  );
};

export default PanelContent;

function Content({ houses, acceptanceId }) {
  const acceptanceSlug = useSearchParamsSelector(
    searchParamSelectors[searchParamKeys.acceptance]
  );

  const onItemClick = useItemClick();

  const handleClick = useEvent((houseId) => {
    onItemClick({ acceptanceId, houseId });
  });

  return (
    <ul className={styles.list}>
      {houses.map((house) => (
        <HouseCard
          key={house.id}
          house={house}
          onClick={handleClick}
          actionsSlot={
            <DownloadSummarySlot
              acceptanceId={acceptanceId}
              houseId={house.id}
            />
          }
          isActive={
            acceptanceSlug === createAcceptanceSlug(acceptanceId, house.id)
          }
        />
      ))}
    </ul>
  );
}

function DeleteBtn({ acceptanceId }) {
  const invalidate = useAcceptanceViewInfoInvalidate();

  const { getParams, setParams } = useSearchParamsMethods();

  const { mutate, isLoading } = useDeleteAcceptance({
    onSuccess: async (data, variables) => {
      if (data.success) {
        const deletedId = variables;
        const { acceptanceId } = parseAcceptanceSlug(
          getParams()[searchParamKeys.acceptance]
        );

        if (acceptanceId === deletedId) {
          setParams({
            [searchParamKeys.acceptance]: undefined,
            [searchParamKeys.calendarPage]: undefined,
          });
        }

        invalidate();
      } else {
        message.error(data.message || 'Не удалось удалить приемку');
      }
    },
  });

  const handleClick = () => mutate(acceptanceId);

  return (
    <OptionButton
      type={OptionButton.types.danger}
      icon={isLoading ? 'loading' : 'delete'}
      tooltipTitle="Удалить приемку"
      onClick={handleClick}
      className={styles.deleteBtn}
    />
  );
}
